// src/PasswordPromptModal.js
import React, { useState, useEffect } from "react";
import "../../../PasswordPromptModal.css";
import config from "../../../config";

const PasswordPromptModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
}) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      setPassword("");
      setError("");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!password) {
      setError("Please enter a password");
      return;
    }

    if (password === config.deviceSettingsPassword) {
      onConfirm();
      setPassword("");
      setError("");
    } else {
      setError("Incorrect password");
      setPassword("");
    }
  };

  const handleClose = () => {
    setPassword("");
    setError("");
    onClose();
  };

  return (
    <>
      <div className="password-prompt-overlay" onClick={handleClose} />
      <div className="password-prompt-modal">
        <h2>{title || "Password Required"}</h2>
        <div className="password-prompt-content">
          {message && <p className="password-prompt-message">{message}</p>}

          <form onSubmit={handleSubmit}>
            <div className="password-input-group">
              <label htmlFor="password">Enter Password:</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus
                className={error ? "error" : ""}
              />
              {error && <span className="password-error">{error}</span>}
            </div>

            <div className="password-prompt-actions">
              <button
                type="button"
                className="password-cancel-btn"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button type="submit" className="password-confirm-btn">
                Confirm
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default PasswordPromptModal;
